<template>
  <div>
    <el-dialog
        :visible.sync="visible"
        width="40%"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        :close-on-press-escape='false'
        :showClose="false"
    >
      <i class="el-icon-success icon"></i>
      <p>
        {{ tableInfo.msg }}
      </p>
      <div class="botBtn">
        <el-button key="back" @click="handleOk" type="primary">OK</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      visible: false,
      value: '',
      confirmLoading: false,
      tableInfo: {
        result: {},
      },
    }
  },
  computed: {},
  watch: {},
  methods: {
    async handleOk() {
      this.confirmLoading = true
      this.confirmLoading = false
      this.visible = false
      this.$router.push('evidence/list')
    },
    handleShow(data) {
      this.visible = true
      this.tableInfo = Object.assign({}, data)
    },
  },
  created() {
  },
  mounted() {
  },
}
</script>

<style lang="less" scoped>
div {
  text-align: center;

  i {
    font-size: 43px;
    color: #4f9e48;
    display: block;
    margin: 20px 0;
  }
}

p {
  text-align: center;
  line-height: 45px;
  font-size: 15px;
}
.botBtn {
  display: flex;
  justify-content: center;
  margin: 20px 0 0;

  .el-button {
    width: 119px;
    height: 38px;
    text-align: center;
    padding: 0;
  }

  .btn2 {
    background: #FF3333;
    color: #fff;
  }
}
</style>
